import * as React from 'react';
import ResultPageComponent from 'src/modules/commons/result-page/ResultPage.Component';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import ProjectRoundInformationSidebarComponent
  from 'src/modules/project/update/partials/ProjectRoundInformationSidebar.component';
import '../UpdateProject.css';
import ProjectMarketFormComponent
  from 'src/modules/project/update/partials/round-information/ProjectMarketForm.component';
import ProjectSummaryFormComponent
  from 'src/modules/project/update/partials/round-information/ProjectSummaryForm.component';
import ProjectFinancialDataFormComponent
  from 'src/modules/project/update/partials/round-information/ProjectFinancialDataForm.component';
import ProjectBusinessModelFormComponent
  from 'src/modules/project/update/partials/round-information/ProjectBusinessModelForm.component';
import ProjectTeamMembersFormContainer
  from 'src/modules/project/update/partials/round-information/ProjectTeamMembersForm.container';
import ProjectRoundDetailsFormComponent
  from 'src/modules/project/update/partials/round-information/ProjectRoundDetailsForm.component';
import ProjectMetricsFormComponent
  from 'src/modules/project/update/partials/round-information/ProjectMetricsForm.component';
import ProjectData from 'src/value-objects/ProjectData';

export interface ProjectRoundInformationFormComponentProps {
  formData: ProjectData;
  handleClick: (value: string) => void;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  handleSubmit: () => void;
  handleRichEditor: (key: string) => (html: string) => void;
  error: boolean;
  errorMessage: {};
  success: boolean;
  section: string;
}

class ProjectRoundInformationFormComponent extends React.Component<ProjectRoundInformationFormComponentProps> {

  public render(): React.ReactNode {
    return (
      <div className="round-information-form tab-content padding-40">
        <div>
          <div className="sidebar">
            <ProjectRoundInformationSidebarComponent
              section={this.props.section}
              handleClick={this.props.handleClick}
            />
          </div>
          {!this.props.success ?
            <div className="content">
              {this.renderForm(this.props.section)}
            </div> :
            <div className="content">
              <ResultPageComponent
                title="Los datos de la compañía se han guardado correctamente"
                message=""
                success={true}
              />
            </div>
          }
        </div>
        <div className="gap-20"/>
        {!this.props.success ?
          <div>
            <div className="text-right">
              {this.props.section === 'equipo' ?
                null :
                <button
                  type="button"
                  className="btn btn-primary"
                  data-container="body"
                  data-html="true"
                  data-toggle="popover"
                  data-placement="bottom"
                  onClick={(e) => this.props.handleSubmit()}
                >
                  Guardar
                </button>
              }
              <div className="gap-20"/>
              <ErrorMessagesComponent
                errorMessage={this.props.errorMessage}
              />
            </div>
            {/*TODO*/}
            {/*<p className="text-center">
              <button
                className="btn btn-secondary btn-lg"
              >
                Enviar para revisión
              </button>
            </p>*/}
            <div className="gap-20"/>
          </div>
          : null
        }
      </div>
    );
  }

  private renderForm(section: string): React.ReactNode {
    switch (section) {
      case 'resumen':
        return (
          <ProjectSummaryFormComponent
            formData={this.props.formData}
            handleChange={this.props.handleChange}
            handleRichEditor={this.props.handleRichEditor}
          />
        );
      case 'mercado':
        return (
          <ProjectMarketFormComponent
            formData={this.props.formData}
            handleChange={this.props.handleChange}
            handleRichEditor={this.props.handleRichEditor}
          />
        );
      case 'datos-financieros':
        return (
          <ProjectFinancialDataFormComponent
            formData={this.props.formData}
            handleChange={this.props.handleChange}
            handleRichEditor={this.props.handleRichEditor}
          />
        );
      case 'metricas':
        return (
          <ProjectMetricsFormComponent
            formData={this.props.formData}
            handleChange={this.props.handleChange}
            handleRichEditor={this.props.handleRichEditor}
          />
        );
      case 'detalles':
        return (
          <ProjectRoundDetailsFormComponent
            formData={this.props.formData}
            handleChange={this.props.handleChange}
            handleRichEditor={this.props.handleRichEditor}
          />
        );
      case 'modelo-de-negocio':
        return (
          <ProjectBusinessModelFormComponent
            formData={this.props.formData}
            handleChange={this.props.handleChange}
            handleRichEditor={this.props.handleRichEditor}
          />
        );
      case 'equipo':
        return (
          <ProjectTeamMembersFormContainer
            project={this.props.formData}
          />
        );
      case 'documentos':
        return (<div>DOCUMENTOS</div>);
      default:
        return null;
    }
  }
}

export default ProjectRoundInformationFormComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/ProjectRoundInformationForm.component.tsx